<template>
  <Page title="Dashboard">
    <div style="display:flex;">
      <div style="flex:1.2; padding:0 10px;">
        <div style="padding:10px; text-align:center;">
          Termin
        </div>
        <YearlyChart />
      </div>
      <div style="flex:1.5;">
        <LastActivities />
      </div>
      <div style="flex:1">
        <KalendarPHO />
      </div>
    </div>
  </Page>
</template>

<script>
// @ is an alias to /src
import LastActivities from './LastActivities'
import Rekap from './Rekap'
import YearlyChart from './YearlyChart'
import RekapAngka from './RekapAngka'
// import Retribusi from './Retribusi'
import KalendarPHO from './KalendarPHO.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'Home',
  components: {
    Rekap,
    YearlyChart,
    RekapAngka,
    LastActivities,
    // Retribusi,
    KalendarPHO,
  },
  data: () => ({}),
  computed: {
    ...mapGetters({
      user: 'getUser',
    }),
    hasBacklog() {
      let menu = JSON.parse(localStorage.getItem('menu'))
      return menu.find(m => {
        return m.MenuName === 'Backlog'
      })
    },
    hasRTLH() {
      let menu = JSON.parse(localStorage.getItem('menu'))
      return menu.find(m => {
        return m.MenuName === 'RTLH'
      })
    },
  },
  mounted() {},
  methods: {
    GoToBacklog() {
      this.$router.push('/Main/Backlog/Dashboard')
    },
  },
}
</script>
<style lang="scss">
.hide {
  display: none;
}
</style>
